export const formatValueErrorMessage = (errorMessage) => {
  return errorMessage?.replace("Value error,", "").trim();
};